import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeaturesModule } from './features/features.module';
import { SharedModule } from './shared/shared.module';
import { DatePipe } from '@angular/common';
import { InterceptorService } from './core/auth/interceptors/interceptor.service';
import { LoginModule } from './features/login/login.module';
import { ResetPasswordModule } from './features/reset-password/reset-password.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    LoginModule,
    ResetPasswordModule,
    FeaturesModule,
    HttpClientModule,
    FormsModule,
		ReactiveFormsModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
  ],
  providers: [DatePipe ,ReactiveFormsModule ,{ provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },],
  bootstrap: [AppComponent]
})
export class AppModule { }
